<div class="row">
    <div class="col-12 d-flex flex-row">
        <div
            class="mlp-carousel-side d-flex bg-position-right rounded-left"
            (click)="prev()"
            [style.background-image]="prevBackgroundImage"
            [ngClass]="{
                'cursor pointer':
                    venueService.pitchData?.data.attributes.images.large
                        .length > 1
            }"
        >
            <div
                class="align-self-stretch w-100 mlp-carousel-side-image rounded-left"
            ></div>
            <div
                class="mlp-carousel__btn -left px-2"
                *ngIf="
                    venueService.pitchData?.data.attributes.images.large
                        .length > 1
                "
            >
                <mlp-ng-icon name="arrow-left-1"></mlp-ng-icon>
            </div>
        </div>

        <div
            (click)="next()"
            class="mlp-carousel-main"
            [ngClass]="{
                'cursor pointer':
                    venueService.pitchData?.data.attributes.images.large
                        .length > 1
            }"
        >
            <img
                src="{{ currBackgroundImage }}"
                class="img-fluid lazyload"
                alt="{{ imageAltTag() }}"
                imgService="w=578"
                [imgServiceBinding]="currBackgroundImage"
                loading="lazy"
            />
        </div>

        <div
            class="mlp-carousel-side d-flex bg-position-left rounded-right"
            (click)="next()"
            [style.background-image]="nextBackgroundImage"
            [ngClass]="{
                'cursor pointer':
                    venueService.pitchData?.data.attributes.images.large
                        .length > 1
            }"
        >
            <div
                class="align-self-stretch w-100 mlp-carousel-side-image rounded-right"
            ></div>
            <div
                class="mlp-carousel__btn -right px-2"
                *ngIf="
                    venueService.pitchData?.data.attributes.images.large
                        .length > 1
                "
            >
                <mlp-ng-icon name="arrow-right-1"></mlp-ng-icon>
            </div>
        </div>
    </div>
</div>